import React from 'react';
import { ThemeProvider as RooThemeProvider } from '@qga/roo-ui';
import theme from './theme';

export default function ThemeProvider(props) {
  return <RooThemeProvider theme={theme} {...props} />;
}

ThemeProvider.theme = theme;
